// react-native-config web shim. @config/index.js does `import Config from
// "react-native-config"` then re-exports baseURL/appEnv/appVersionCode/etc.
// Native reads these from .env.staging/.env.production at build time; on web we
// return a staging-ish object and "" for anything unset so @config never throws.
// devserver.js injects window.__CM_ENV ("staging" | "prod" | "preprod") before the bundle.
const CM_ENV = (typeof window !== "undefined" && window.__CM_ENV) || "staging";
// devserver.js also reads ANDROID_VERSION_CODE straight out of the real
// .env.<ENV> file (the same one native builds use) and injects it here, so the
// harness always reports whatever build number is actually current -- no
// separate hardcoded number to remember to bump when a release ships. Only
// used if that injection is somehow missing (e.g. a static build served
// without devserver.js).
const ANDROID_VERSION_CODE =
  (typeof window !== "undefined" && window.__CM_ANDROID_VERSION_CODE) ||
  "3146064";
const values = {
  // preprod is prod-side (prod DB; .env.preprod APP_ENV=production).
  APP_ENV: CM_ENV === "prod" || CM_ENV === "preprod" ? "production" : "staging",
  ANDROID_APP_STORE: "GOOGLE",
  // @config exports APP_VERSION = Config.VERSION_CODE, compared client-side
  // against the remote min-version (versionId, fetched from staging at
  // runtime) in UpdateAppModal to decide whether to show the "please update"
  // overlay. Reusing the real ANDROID_VERSION_CODE here (rather than a
  // separately-maintained number) means this can't drift behind the remote
  // minimum the way a one-time hardcoded snapshot did -- a real build's own
  // version code is never behind the backend's own idea of "current".
  VERSION_CODE: ANDROID_VERSION_CODE,
  ANDROID_VERSION_CODE,
  ANDROID_VERSION_NAME:
    (typeof window !== "undefined" && window.__CM_ANDROID_VERSION_NAME) ||
    "1.58.0",
  // Same-origin proxy paths — devserver.js forwards these to the real hosts
  // server-side (no CORS). partner-db .env real targets, for reference:
  //   BASE_URL          https://staging-dev.citymall.dev/api/   (prod citymall.live/api/)
  //   SEARCH_URL        https://search-cf.citymall.live/search/api/
  //   STATIC_PAGE_URL   https://citymall.dev/   (prod citymall.live/)
  //   APPLINKS_BASE_URL https://w.staging-dev.citymall.dev/api/  (prod w.ctml.in/api/)
  BASE_URL: "/api/",
  SEARCH_URL: "/search-api/",
  STATIC_PAGE_URL: "/static-page/",
  APPLINKS_BASE_URL: "/applinks-api/",
  // websocket non-critical for first-screen; harmless handshake failure.
  SOCKET_URL:
    CM_ENV === "prod" || CM_ENV === "preprod"
      ? "wss://citymall.live/partner-db-ws" // .env.production / .env.preprod
      : "wss://staging-dev.citymall.dev/partner-db-ws",
  // misc keys the config module reads; safe placeholders.
  CODEPUSH_KEY: "",
  SENTRY_DSN: "",
  TRACKING_ENABLED: "false",
  MOVEX_PUBLISHABLE_KEY: "",
};
const Config = new Proxy(values, {
  get(t, k) {
    if (k === "__esModule") return undefined;
    return k in t ? t[k] : "";
  },
});
module.exports = { __esModule: true, default: Config };
